


























import { Component, Vue, Prop } from "vue-property-decorator";
import { ExpertsVideoData } from "@/types";
@Component({
  name: "ExpertsVideo",

  components: {},
})
export default class ExpertsVideo extends Vue {
  @Prop({ type: Number }) videos!: number;
  @Prop({ type: Number }) views!: number;
  get expertsCounter(): Array<ExpertsVideoData> {
    return [
      {
        count: this.videos,
        description: `${this.$t("experts.experts_video_statistic_item1")}`,
      },
      {
        count: this.views,
        description: `${this.$t("experts.experts_video_statistic_item2")}`,
      },
    ];
  }
}
